import React from 'react';


export function DisplayDate(ddProps: { date: Date | undefined | null }) {
    const titleOpts: Intl.DateTimeFormatOptions = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"

    };
    return (
        <span className="display-date" title={ddProps.date?.toLocaleString(undefined, titleOpts)}>
            {ddProps.date?.toLocaleDateString() ?? " -- "}
        </span>
    );
}
